import Loading from '../misc/Loading';
import React from 'react';
import {NavLink as Link} from 'react-router-dom';
import _ from 'lodash';
import {Table} from 'react-bootstrap';
import moment from 'moment';
import WarrantyPeriodModel from '../../../../model/warrantyPeriod';
import PublishStatusTableRow from '../table/PublishStatusTableRow';
import PublishStatusDot from '../../../misc/PublishStatusDot';
import withRouter from '/src/components/misc/withRouter';
import {mapMakeToMakeId} from '/src/components/misc/utils';

class WarrantyPeriodList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      makeId: null,
      makeSlug: null,
      makeName: null,
      hideArchived: true,
      warrantyPeriods: null
    };

    document.title = `Admin - Garantiperioder - ${this.props.match.params.make}`;
  }

  componentDidMount() {
    if (this.props.match.params.make) {
      this.fetchWarrantyPeriods(this.props.match.params.make);
    }
  }

  UNSAFE_componentWillReceiveProps(next) { // eslint-disable-line camelcase
    if (next.match.params.make) {
      this.setState({
        makeId: null,
        make: null,
        warrantyPeriods: null
      });
      this.fetchWarrantyPeriods(next.match.params.make);
    }
  }

  fetchWarrantyPeriods(make) {
    const makeId = mapMakeToMakeId[make];
    WarrantyPeriodModel.getByMakeId(makeId, 2).then((warrantyPeriods) => {
      this.setState({
        makeId,
        makeSlug: make,
        makeName: _.capitalize(make),
        warrantyPeriods
      });
    });
  }

  toggleShowArchived() {
    this.setState({
      hideArchived: !this.state.hideArchived
    });
  }

  render() {
    if (!this.state.warrantyPeriods) {
      return (
        <Loading title="Garantiperioder" text='Laster garantiperioder'/>
      );
    }

    return (
      <section className="mf-model mf-padding-top-20">
        <ol className="breadcrumb">
          <li><Link to="/">Forsiden</Link></li>
          <li>Garantiperioder</li>
        </ol>

        <div className="page-header">
          <div className="row">
            <div className="col-xs-12 col-sm-6">
              <h1>
                Garantiperioder<br />
                <small>{this.state.makeName}</small>
              </h1>
            </div>
            <div className="col-xs-12 col-sm-6 text-right">
              <button onClick={() => {
                this.toggleShowArchived();
              }} className="btn btn-info" disabled={this.state.working}>
                {this.state.hideArchived ? 'Vis arkiverte' : 'Skjul arkiverte'}
              </button>
              &nbsp;
              &nbsp;
              <Link
                to={`/warrantyperiods/${this.state.makeSlug}/new`}
                className="btn btn-success"
                disabled={this.props.working}
              >
                Ny periode
              </Link>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            {this.state.warrantyPeriods.length > 0 &&
              <Table striped bordered hover>
                <thead>
                  {this.state.makeSlug !== 'mitsubishi' &&
                    <tr>
                      <th title="Publiseringsstatus"></th>
                      <th>Tittel</th>
                      <th>Periode</th>
                      <th>Gjelder</th>
                      <th>Har dokument/tekst</th>
                      <th>Garanti-tekst</th>
                      <th>Lakk-tekst</th>
                      <th>Rust-tekst</th>
                      <th>Batteri-tekst</th>
                    </tr>
                  }
                  {this.state.makeSlug === 'mitsubishi' &&
                    <tr>
                      <th title="Publiseringsstatus"></th>
                      <th>Tittel</th>
                      <th>Gjelder</th>
                      <th>Import type</th>
                      <th>Har dokument/tekst</th>
                      <th>Nybil-/rust-data</th>
                      <th>Batteri-data</th>
                    </tr>
                  }
                </thead>
                <tbody>
                  {this.state.warrantyPeriods.map((period) => {
                    if (this.state.hideArchived && period.archived) {
                      return;
                    }

                    const isMMC = (this.state.makeSlug === 'mitsubishi');

                    let fileIcon = <i className="fa fa-times text-danger"></i>;
                    if (period.warrantyDocument) {
                      fileIcon = <i className="fa fa-check text-succuss"></i>;
                    }

                    const validFor = [];
                    if (period.electric) {
                      validFor.push('Elbil');
                    }
                    if (period.van) {
                      validFor.push('Varebil');
                    }

                    const fromDate = (period.fromDate ? moment(period.fromDate).format('DD.MM.YYYY') : '-');
                    const toDate = (period.toDate ? moment(period.toDate).format('DD.MM.YYYY') : '-');

                    const importTypes = [];
                    if (period.usedImport) {
                      importTypes.push('Brukt');
                    }

                    if (period.mgImport) {
                      importTypes.push('MG');
                    }

                    if (isMMC) {
                      let regData = <i className="fa fa-times text-danger"></i>;
                      if (period.jsonReg) {
                        regData = <i className="fa fa-check text-succuss"></i>;
                      }
                      let batteryData = <i className="fa fa-times text-danger"></i>;
                      if (period.jsonBattery) {
                        batteryData = <i className="fa fa-check text-succuss"></i>;
                      }

                      return (
                        <PublishStatusTableRow entry={period} key={`period-${period.id}`}>
                          <td className="text-center">
                            <PublishStatusDot entry={period} />
                          </td>
                          <td>
                            <Link to={`/warrantyperiods/${this.state.makeSlug}/${period.id}`}>{period.title}</Link>
                          </td>
                          <td>{validFor}</td>
                          <td>{importTypes.length ? importTypes.join(', ') : '-'}</td>
                          <td>{fileIcon}</td>
                          <td>{regData}</td>
                          <td>{batteryData}</td>
                        </PublishStatusTableRow>
                      );
                    }

                    return (
                      <PublishStatusTableRow entry={period} key={`period-${period.id}`}>
                        <td className="text-center">
                          <PublishStatusDot entry={period} />
                        </td>
                        <td>
                          <Link to={`/warrantyperiods/${this.state.makeSlug}/${period.id}`}>{period.title}</Link>
                        </td>
                        <td>{fromDate} - {toDate}</td>
                        <td>{validFor}</td>
                        <td>{fileIcon}</td>
                        <td>{period.standardWarrantyText}</td>
                        <td>{period.paintWarrantyText}</td>
                        <td>{period.rustWarrantyText}</td>
                        <td>{period.batteryWarrantyText}</td>
                      </PublishStatusTableRow>
                    );
                  })}
                </tbody>
              </Table>
            }

            {this.state.warrantyPeriods.length <= 0 &&
              <p className="alert alert-info">Nei, du, her var det jaggu tomt! Kom deg opp av sofaen og opprett noen garantiperioder!</p>
            }
          </div>
        </div>
      </section>
    );
  }
}

export default withRouter(WarrantyPeriodList);
